import React from "react";

import ManuscriptTextEditorHost from "components/organisms/manuscript/codemirror/ManuscriptTextEditorHost";

function ManuscriptVisualEditor(props) {
    return (
        <ManuscriptTextEditorHost
            {...props}
            basicSetup={{
                drawSelection: false,
                foldGutter: false,
                highlightActiveLine: true,
                highlightActiveLineGutter: false,
                highlightSelectionMatches: false,
                lineNumbers: true,
                searchKeymap: true,
            }}
        />
    );
}

export default ManuscriptVisualEditor;
